import React from "react"
import { fnGetValueByKey, getValueByKeyObject } from "../../helpers/functions"
import { Alert, FormGroup, Label } from "reactstrap"
import { InputDateGroup } from "../Common/InputDateGroup"
import ComboBoxAutomatic from "./ComboBoxAutomatic"

const TranspaleStringToComponente = ({item, preFilter = [], onPreFilter = () => {}}) => {
    if (item?.Chave_Transacao_Componente_Tipo === 'ATRIBUTO') return <></>

    const attributes = item.Childrens

    const handlePreFilter = ({ value, field }, id) => {
      onPreFilter({ [id]: { value, field } })
    }

    const automaticElements = () => {
      let defaultValue = fnGetValueByKey(attributes, 'VALOR')
      let maxLength = Number(fnGetValueByKey(attributes, 'TAMANHO_CARACTERES')) || 10
      switch (fnGetValueByKey(attributes, 'TIPO')) {
        case 'Date':
          if (defaultValue && !preFilter[0])
            handlePreFilter(
              {
                value: defaultValue,
                field: fnGetValueByKey(attributes, 'TITULO')
              },
              fnGetValueByKey(attributes, 'ID')
            )
          return (
            <FormGroup>
              <Label className="text-color-cinza4">{fnGetValueByKey(attributes, 'TITULO')}</Label>
              <InputDateGroup
                id={fnGetValueByKey(attributes, 'ID')}
                value={
                  preFilter[0]?.[fnGetValueByKey(attributes, 'ID')]?.value
                    ?.split('/')
                    ?.reverse()
                    ?.join('-') ||
                  defaultValue?.split('/')?.reverse()?.join('-') ||
                  ''
                }
                onChange={e =>
                  handlePreFilter(
                    {
                      value: e.target.value.split('-').reverse().join('/'),
                      field: fnGetValueByKey(attributes, 'TITULO')
                    },
                    fnGetValueByKey(attributes, 'ID')
                  )
                }
                placeholder={
                  fnGetValueByKey(attributes, 'PLACEHOLDER') || 'dd/mm/aaaa'
                }
                maxDate={fnGetValueByKey(attributes, 'MAX_DATE') || null}
                minDate={fnGetValueByKey(attributes, 'MIN_DATE') || null}
              />
            </FormGroup>
          )
        case 'Texto':
          return (
            <FormGroup>
              <span id={fnGetValueByKey(attributes, 'ID')} >{defaultValue}</span>
            </FormGroup>
          )
        case 'Input':
          if (defaultValue && !preFilter[0]){
            handlePreFilter(
              {
                value: defaultValue,
                field: fnGetValueByKey(attributes, 'TITULO')
              },
              fnGetValueByKey(attributes, 'ID')
            )
          }

          const alienadoInput = JSON.parse(
            fnGetValueByKey(attributes, 'ALIENADO') || '{}'
          )
            
          return (
            <FormGroup>
              <Label className="text-color-cinza4">{fnGetValueByKey(attributes, 'TITULO')}</Label>
              <input
                name={fnGetValueByKey(attributes, 'ID')}
                className="form-control"
                id={fnGetValueByKey(attributes, 'ID')}
                defaultValue={
                  preFilter[0]?.[fnGetValueByKey(attributes, 'ID')]?.value ||
                  defaultValue ||
                  ''
                }
                onChange={e =>
                  handlePreFilter(
                    {
                      value: e.target.value,
                      field: fnGetValueByKey(attributes, 'TITULO')
                    },
                    fnGetValueByKey(attributes, 'ID')
                  )
                }
                disabled={
                    fnGetValueByKey(attributes, 'EDITAVEL') !== 'S' || 
                    typeof alienadoInput === 'object' &&
                    !preFilter.some(obj =>
                        Object.prototype.hasOwnProperty.call(obj, alienadoInput) && !!obj[alienadoInput].value
                    )
                }
                placeholder={fnGetValueByKey(attributes, 'PLACEHOLDER') || ''}
                maxLength={maxLength}
              />
            </FormGroup>
          )
        case 'Combobox':
          const id = fnGetValueByKey(attributes, 'ID')
          const title = fnGetValueByKey(attributes, 'TITULO')
          const procName = fnGetValueByKey(attributes, 'PROCEDURE')
          const procParams = JSON.parse(
            fnGetValueByKey(attributes, 'PROCEDURE_PARAM') || '{}'
          )
          let dataOptions = []

          try {
            dataOptions = JSON.parse(fnGetValueByKey(attributes, 'PROCEDURE_RESULTSET'))
          } catch (error) {
            console.log(`${id}: Combobox sem dados pré carregados`);
          }

          try {
            defaultValue = JSON.parse(defaultValue)[0]
          } catch (error) {
            console.log(`${id}: Combobox sem valor padrão`);
          }

          const value = (preFilter[0] && preFilter[0][id]) || defaultValue || ''
  
          const alienado = JSON.parse(
            fnGetValueByKey(attributes, 'ALIENADO') || '{}'
          )

          const isMulti = fnGetValueByKey(attributes, 'MULTISELECAO') === 'True'

          return (
            <ComboBoxAutomatic
              id={id}
              titulo={title}
              placeholder={
                fnGetValueByKey(attributes, 'PLACEHOLDER') || 'Selecionar'
              }
              isDisabled={
                fnGetValueByKey(attributes, 'EDITAVEL') !== 'S' || 
                (typeof alienado === 'object' &&
                !preFilter.some(obj =>
                  Object.prototype.hasOwnProperty.call(obj, alienado)
                ))
              }
              idAlienated={alienado}
              alienated={
                typeof alienado === 'object' && preFilter[0]
                  ? getValueByKeyObject(preFilter, alienado)
                  : []
              }
              maxLength={maxLength}
              procName={procName}
              procParams={procParams}
              initialValue={value}
              isMulti={isMulti}
              valueOptions={dataOptions}
              callbackSelected={selected => {
                onPreFilter({ ...preFilter[0], ...selected })
              }}
              callbackRemoveSelected={id => {
                const newPreFilter = preFilter[0]
                delete newPreFilter[id]
                onPreFilter(newPreFilter)
              }}
            />
          )
        default:
          return (
            <Alert className="my-2" color="warning">
              Input não mapeado
            </Alert>
          )
      }
    }    

    return (
      <div className={`${fnGetValueByKey(attributes, "LARGURA_COLUNA") || 'col-12'}`} key={item?.ID_Transacao_Componente}>
        {automaticElements()}
      </div>
    )
  }

export default TranspaleStringToComponente